import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "interactive-block-wrap" }
const _hoisted_2 = { class: "interactive-block" }

import {
  HelpModel,
  terminal_solution_interactive_block,
  terminal_solution_interactive_block_1,
  terminal_solution_interactive_block_2,
  terminal_solution_interactive_block_3,
  terminal_solution_interactive_block_4,
} from "@/shared";
import {onBeforeMount, ref} from "vue";
import {InteractiveBlock} from "@/features";


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-solution-interactive-block',
  setup(__props) {

onBeforeMount(() => {
  initArrData();
});

const arrData = ref<Array<HelpModel>>(new Array<HelpModel>());

const initArrData = () => {
  arrData.value.push(new HelpModel({
    Text: "terminal_solution_interactive_block_first_text",
    Image: terminal_solution_interactive_block,
    Id: 1,
  }));
  arrData.value.push(new HelpModel({
    Text: "terminal_solution_interactive_block_second_text",
    Id: 2,
    Image: terminal_solution_interactive_block_1,
  }));
  arrData.value.push(new HelpModel({
    Text: "terminal_solution_interactive_block_third_text",
    Image: terminal_solution_interactive_block_2,
    Id: 3,
  }));
  arrData.value.push(new HelpModel({
    Text: "terminal_solution_interactive_block_fourth_text",
    Image: terminal_solution_interactive_block_3,
    Id: 4,
  }));
  arrData.value.push(new HelpModel({
    Text: "terminal_solution_interactive_block_fifth_text",
    Image: terminal_solution_interactive_block_4,
    Id: 5,
  }));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(InteractiveBlock), { arrData: arrData.value }, null, 8, ["arrData"])
    ])
  ]))
}
}

})